export default __webpack_public_path__ + "static/media/os_4.80c2487a.mp3";